const clearFilter = () => {
    // hide selected filter
    for (const btnobj of document.getElementsByClassName("filterbttn")) {
        btnobj.style.cssText = "display:none;"
    }
}
export { clearFilter };